import React from 'react';
import SessionPage from './SessionPage';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { compose } from 'underscore';

import {
    selectedSessionSelector,
    sessionSpeakersSelector,
    currentSessionVirtualDetailsSelector,
} from '../../../selectors/SessionSelectors';
import {
    settingsSelector,
    ticketsSelectionDataSelector,
} from '../../../selectors/AgendaSelectors';
import {
    eventSelector,
    getInternalAgendaUrl,
    isEventIndependentSelector,
} from '../../../selectors/EventSelectors';
import {
    isLoginShownSelector,
    loginLoadingStateSelector,
    enableLoginRegistrationPopUpSelector,
} from '../../../selectors/LoginSelectors';
import {
    fetchAgendaSettings,
    fetchMarkers,
    toggleMarker,
    clientNavigationAction,
    setScrollToSessionBroadcastAction,
} from '../../../actions/AgendaActions';
import {
    showEmailLogin,
    hideEmailLogin,
    setLoginV2SpinnerOrigin,
    setLoginV2OffsetTop,
} from '../../../actions/LoginActions';
import {
    fetchSessionData,
    sendRate,
    setVirtualSessionDetails,
    setRecordUrl
} from '../../../actions/SessionActions';
import { fetchSponsorsByEvent } from '../../../actions/SponsorActions';
import { eventUrlsSelector } from '../../../selectors/EventSelectors';
import { isRingAvailableSelector, isRingWorksSelector } from '../../../selectors/RingSelectors';
import { resolveSessionTopMargin } from './sessionTopMargin';
import {
    toggleSessionRegistrationStatusPerSession,
    openCloseTicketSelectionPopUp,
    setSessionFullRegistration,
    getUserTicketsByEvent
} from '../../../actions/UserProfileActions';

const mapStateToProps = (state, ownProps) => {
    const {
        agendaReducer: { serverRendered },
        siteConfReducer: { siteConf },
        meReducer: { me },
        sessionReducer: { rate, feedback, recordUrl, error: sessionNotFoundError }
    } = state;

    const {
        previewSessionId,
        showControlPanel,
        topMargin,
        showBackgroundColor,
        displayInContainer,
        showCompactLists,
        shouldUseCompactDescription,
        stickSectionsToLeft,
        sessionViewType
    } = ownProps;

    const routeSessionId = ownProps.routeParams && ownProps.routeParams.id && parseInt(ownProps.routeParams.id);
    const sessionId = routeSessionId || previewSessionId;
    const isEventIndependent = isEventIndependentSelector(state);
    const isVirtualVenueEnabled = isRingWorksSelector(state);
    const session = selectedSessionSelector(state);
    const calculatedTopMargin = resolveSessionTopMargin({
        topMargin,
        isEventIndependent,
        isVirtualVenueEnabled,
        hasSessionBanner: !!session?.imageUrl,
    });

    return {
        event: eventSelector(state),
        sessionId,
        session,
        settings: settingsSelector(state),
        enableLoginRegistrationPopUp: enableLoginRegistrationPopUpSelector(state),
        serverRendered,
        siteConf,
        speakers: sessionSpeakersSelector(state),
        agendaUrl: getInternalAgendaUrl(state),
        rate,
        feedback,
        isSessionRegistrationEnabled: state.agendaReducer.isSessionRegistrationEnabled,
        me,
        eventUrls: eventUrlsSelector(state),
        isEmailLoginShown: isLoginShownSelector(state),
        loginV2LoadingState: loginLoadingStateSelector(state),
        showControlPanel,
        topMargin: calculatedTopMargin,
        showBackgroundColor,
        displayInContainer,
        showCompactLists,
        shouldUseCompactDescription,
        stickSectionsToLeft,
        sessionViewType,
        ticketsSelectionData: ticketsSelectionDataSelector(state),
        currentVirtualSessionDetails: currentSessionVirtualDetailsSelector(state),
        scrollToBroadcast: state.agendaReducer.scrollToBroadcast,
        recordUrl,
        isRingAvailable: isRingAvailableSelector(state),
        sessionNotFoundError,
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchSessionData,
    fetchAgendaSettings,
    fetchMarkers,
    toggleMarker,
    sendRate,
    showEmailLogin,
    hideEmailLogin,
    fetchSponsorsByEvent,
    toggleSessionRegistrationStatusPerSession,
    openCloseTicketSelectionPopUp,
    setSessionFullRegistration,
    getUserTicketsByEvent,
    setVirtualSessionDetails,
    clientNavigationAction,
    setScrollToSessionBroadcastAction,
    setRecordUrl,
    setLoginV2OffsetTop,
    setLoginV2SpinnerOrigin,
}, dispatch);


export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
)(SessionPage);
